import { render, staticRenderFns } from "./FailurePayment.vue?vue&type=template&id=4de297b2&"
import script from "./FailurePayment.vue?vue&type=script&lang=ts&"
export * from "./FailurePayment.vue?vue&type=script&lang=ts&"
import style0 from "./FailurePayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports